import React from 'react';
import './FloatingLabel.css';
import { useTranslation } from 'react-i18next';

const FloatingSelect = ({ label, options, value, onChange, ...props }) => {
  const { t } = useTranslation();

  return (
    <div className="float-label-select">
      <select value={value} onChange={onChange} {...props}>
        <option value="" disabled>{`${t('common.select')}`} {label}</option>
        {options && options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <label>{label}</label>
    </div>
  );
};

export default FloatingSelect;